import { ContextButton } from "@/components/atoms/ContextButton";
import { useDomains } from "@/hooks/useDomains";
import { useUI } from "@/hooks/useUI";

export interface ContextButtonConnectedProps {
  /**
   * Click handler for the button
   */
  onClick?: () => void;
  /**
   * Additional CSS classes
   */
  className?: string;
}

export function ContextButtonConnected({
  onClick,
  className,
}: ContextButtonConnectedProps) {
  const { hasPersonaOrContextSelected } = useUI();
  const { currentDomain, isLoadingDomains } = useDomains();

  const contextSelected = hasPersonaOrContextSelected();
  const loading = isLoadingDomains || !currentDomain;

  return (
    <ContextButton
      contextSelected={contextSelected}
      loading={loading}
      onClick={onClick}
      className={className}
    />
  );
}

